import React from 'react';

import * as S from './RadioGroup.styles';

export const RadioGroup = ({ children, onChange, value, className }) => {
  return (
    <S.Container className={className}>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          checked: String(child.props.value) === String(value),
          onChange,
        })
      )}
    </S.Container>
  );
};
